export const matchesQuery = (value: string, query: string) => {
  if (!value) return false
  const lowerQuery = query.toLowerCase()
  return value.toLowerCase().includes(lowerQuery)
}

export const filterSectionsBySearch = <T extends { label: string }>(
  sections: readonly { title: string; items: readonly T[] }[],
  searchQuery: string
) => {
  if (searchQuery.trim() === '') return sections
  const lowerQuery = searchQuery.trim().toLowerCase()
  return sections
    .map((section) => {
      const sectionTitleMatches = matchesQuery(section.title, lowerQuery)
      if (sectionTitleMatches) {
        return section
      }
      const filteredItems = section.items.filter((item) => matchesQuery(item.label, lowerQuery))
      return { ...section, items: filteredItems }
    })
    .filter((section) => section.items.length > 0 || matchesQuery(section.title, lowerQuery))
}
